"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2656],{

/***/ 96654:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ AddNoteModal; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(57135);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(59072);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(80677);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50959);
/* harmony import */ var services_allServices__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63700);
/* harmony import */ var components_FormElements_SimpleTextArea__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88234);
/* harmony import */ var components_FormElements_Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62303);
/* harmony import */ var store_ConfigurationStore__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(20363);
/* harmony import */ var _Toast_AllToast__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(86749);






// import Image from 'next/image';




function AddNoteModal(param) {
    var setOpenModal = param.setOpenModal, onClick = param.onClick, basket = param.basket, product = param.product;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,store_ConfigurationStore__WEBPACK_IMPORTED_MODULE_5__/* .useConfigurationStore */ .w)(function(state) {
        return [
            state.configurationNote,
            state.setConfigurationNote
        ];
    }), 2), configurationNote = ref[0], setConfigurationNote = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), text = ref1[0], setText = ref1[1];
    var onSetNote = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function() {
            var configure, configure1;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!basket) return [
                            3,
                            2
                        ];
                        configure = {
                            note: text
                        };
                        return [
                            4,
                            (0,services_allServices__WEBPACK_IMPORTED_MODULE_2__/* .updateBasketNote */ .fI)(configure).then(function(res) {
                                (0,_Toast_AllToast__WEBPACK_IMPORTED_MODULE_6__/* .successToast */ .Qm)("Başarılı", "Notunuz başarıyla g\xfcncellendi.");
                            })
                        ];
                    case 1:
                        _state.sent();
                        setOpenModal(false);
                        return [
                            3,
                            6
                        ];
                    case 2:
                        if (!product) return [
                            3,
                            4
                        ];
                        configure1 = {
                            basket_id: product.basket_id,
                            basket_product_id: product.id,
                            product_id: product.product_id,
                            product_note: text
                        };
                        return [
                            4,
                            (0,services_allServices__WEBPACK_IMPORTED_MODULE_2__/* .updateBasketProductNote */ .jF)(configure1, product.type).then(function(res) {
                                (0,_Toast_AllToast__WEBPACK_IMPORTED_MODULE_6__/* .successToast */ .Qm)("Başarılı", "Notunuz başarıyla g\xfcncellendi.");
                            })
                        ];
                    case 3:
                        _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setConfigurationNote(text);
                        _state.label = 5;
                    case 5:
                        setOpenModal(false);
                        _state.label = 6;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function onSetNote() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (basket) {
            (0,services_allServices__WEBPACK_IMPORTED_MODULE_2__/* .getBasketNote */ .ps)().then(function(res) {
                if (res !== null) {
                    setText(res);
                }
            });
        } else {
            if (product) {
                (0,services_allServices__WEBPACK_IMPORTED_MODULE_2__/* .getBasketProductNote */ .$C)(product.basket_id, product.id, product.product_id, product.type).then(function(res) {
                    if (res !== null) {
                        setText(res);
                    }
                });
            } else {
                setText(configurationNote);
            }
        }
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "fixed inset-0 z-10 overflow-y-auto ",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex items-end justify-center min-h-screen pt-4 pb-20 text-center sm:block sm:p-0 ",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "fixed inset-0 transition-opacity",
                    "aria-hidden": "true",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "absolute inset-0 bg-gray-500 opacity-75"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "hidden sm:inline-block sm:align-middle sm:h-screen",
                    "aria-hidden": "true"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "inline-block overflow-hidden text-left align-bottom transition-all transform bg-white rounded-lg shadow-xl sm:my-8 sm:align-middle sm:max-w-2xl sm:w-full",
                    role: "dialog",
                    "aria-modal": "true",
                    "aria-labelledby": "modal-headline",
                    style: {
                        overflow: "initial"
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "bg-white rounded-md",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex items-center justify-between px-5 py-5 border-b border-makdosSecondaryGray",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                        className: "text-2xl font-semibold",
                                        children: "Siparişe A\xe7ıklama Ekle"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                        onClick: function() {
                                            return setOpenModal(false);
                                        },
                                        className: "text-2xl cursor-pointer ri-close-line text-passive"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex flex-col items-center justify-center w-full px-5 pt-4 pb-5 ",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "w-full px-",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_FormElements_SimpleTextArea__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                            value: text,
                                            onChange: function(v) {
                                                return setText(v);
                                            },
                                            labelName: "A\xe7ıklama",
                                            textAreaName: "note",
                                            rows: "4",
                                            placeholder: "L\xfctfen isteklerinizi detaylı yazınız..."
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "flex justify-end w-full mt-3",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_FormElements_Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                            type: "button",
                                            onClick: function() {
                                                return onSetNote();
                                            },
                                            buttonText: "Kaydet",
                                            buttonRightIcon: "ri-checkbox-circle-line"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
}


/***/ }),

/***/ 12917:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var components_FormElements_Button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62303);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50959);
/* harmony import */ var components_ContentAlerts_AlertInfo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65389);




function BillingInfoModal(param) {
    var setOpenModal = param.setOpenModal, title = param.title, billingAddress = param.billingAddress;
    var ref, ref1, ref2, ref3, ref4;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "fixed inset-0 z-10 overflow-y-auto ",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex items-end justify-center min-h-screen pt-4 pb-20 text-center sm:block sm:p-0 ",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "fixed inset-0 transition-opacity",
                    "aria-hidden": "true",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "absolute inset-0 bg-gray-500 opacity-75"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "hidden sm:inline-block sm:align-middle sm:h-screen",
                    "aria-hidden": "true"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "inline-block overflow-hidden text-left align-bottom transition-all transform bg-white rounded-lg shadow-xl sm:my-8 sm:align-middle sm:max-w-3xl sm:w-full",
                    role: "dialog",
                    "aria-modal": "true",
                    "aria-labelledby": "modal-headline",
                    style: {
                        overflow: "initial"
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "bg-white rounded-md",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex items-center justify-between px-3 py-3 border-b border-makdosSecondaryGray",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h3", {
                                        className: "text-xl font-medium",
                                        children: [
                                            title,
                                            " Fatura"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                        onClick: function() {
                                            return setOpenModal(false);
                                        },
                                        className: "text-2xl cursor-pointer ri-close-line text-passive"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "flex flex-col items-center justify-center w-full px-5 pt-4 pb-5 ",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "grid w-full grid-cols-8 gap-5",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "flex justify-between col-span-2",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    children: "Adres T\xfcr\xfc"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    children: ":"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "col-span-6",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                children: (billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.is_personal) ? "Kişisel" : "Kurumsal"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "flex justify-between col-span-2",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    children: "Ad Soyad"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    children: ":"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "col-span-6",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                children: [
                                                    billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.name,
                                                    " ",
                                                    billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.surname,
                                                    " "
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "flex justify-between col-span-2",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    children: "TC Kimlik No"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    children: ":"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "col-span-6",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                children: [
                                                    billingAddress === null || billingAddress === void 0 ? void 0 : (ref = billingAddress.tc_no) === null || ref === void 0 ? void 0 : ref.slice(0, 7),
                                                    "****"
                                                ]
                                            })
                                        }),
                                        (billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.company_name) !== "" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "flex justify-between col-span-2",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            children: "Firma \xdcnvanı"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            children: ":"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "col-span-6",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        children: billingAddress.company_name
                                                    })
                                                })
                                            ]
                                        }),
                                        (billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.tax_office) !== "" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "flex justify-between col-span-2",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            children: "Vergi Dairesi"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            children: ":"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "col-span-6",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        children: billingAddress.tax_office
                                                    })
                                                })
                                            ]
                                        }),
                                        billingAddress.tax_no !== "" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "flex justify-between col-span-2",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            children: "Vergi No"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            children: ":"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "col-span-6",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                        children: [
                                                            (ref1 = billingAddress.tax_no) === null || ref1 === void 0 ? void 0 : ref1.slice(0, 6),
                                                            "****"
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "flex justify-between col-span-2",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    children: "\xdclke"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    children: ":"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "col-span-6",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                children: billingAddress === null || billingAddress === void 0 ? void 0 : (ref2 = billingAddress.country) === null || ref2 === void 0 ? void 0 : ref2.text
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "flex justify-between col-span-2",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    children: "İl"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    children: ":"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "col-span-6",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                children: billingAddress === null || billingAddress === void 0 ? void 0 : (ref3 = billingAddress.state) === null || ref3 === void 0 ? void 0 : ref3.text
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "flex justify-between col-span-2",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    children: "İl\xe7e"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    children: ":"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "col-span-6",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                children: billingAddress === null || billingAddress === void 0 ? void 0 : (ref4 = billingAddress.cities) === null || ref4 === void 0 ? void 0 : ref4.text
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "flex justify-between col-span-2",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    children: "Posta Kodu"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    children: ":"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "col-span-6",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                children: billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.post_code
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "flex justify-between col-span-2",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    children: "Adres"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    children: ":"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "col-span-6",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                children: billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.address
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "px-5 py-2 ",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_ContentAlerts_AlertInfo__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    title: "Bilgilendirme",
                                    message: "Fatura adresinizi M\xfcşteri Paneli -> Profil Ayarları -> Fatura Adreslerim kısmından d\xfczenleyebilirsiniz."
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "flex justify-end w-full pt-2 pb-6 pr-5",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_FormElements_Button__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                    onClick: function() {
                                        return setOpenModal(false);
                                    },
                                    buttonText: "Tamam",
                                    buttonRightIcon: "ri-checkbox-circle-line"
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (BillingInfoModal);


/***/ }),

/***/ 11898:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50959);


function Numeric(param) {
    var value = param.value, setNumericValue = param.setNumericValue;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        type: "button",
        className: "w-full py-2 pl-1 pr-1 border flex justify-between items-center rounded-md border-makdosSecondaryGray text-textGray outline-none focus:outline-none focus:border-0 focus:ring-1 focus:ring-makdosYellow",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "w-full outline-none",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                    className: "w-full outline-none group border-none focus:border-none focus:outline-none focus:ring-0",
                    type: "number",
                    onChange: function(e) {
                        return setNumericValue(e.target.value);
                    },
                    value: value
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex items-center",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "mr-1 bg-makdosSecondaryGray w-0.5 h-5"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex flex-col relative ",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                onClick: function() {
                                    return setNumericValue(value + 1);
                                },
                                className: "ri-arrow-up-s-fill text-2xl py-0.5 leading-3"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                onClick: function() {
                                    return setNumericValue(value - 1);
                                },
                                className: "ri-arrow-down-s-fill text-2xl py-0.5 leading-3"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Numeric);


/***/ }),

/***/ 65389:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50959);


function AlertInfo(param) {
    var title = param.title, message = param.message;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "w-full py-2 px-2 rounded-md bg-blueAlertBg border border-blueAlertBorder",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex items-center",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                        width: "24",
                        height: "25",
                        viewBox: "0 0 24 25",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M12 22.5C6.477 22.5 2 18.023 2 12.5C2 6.977 6.477 2.5 12 2.5C17.523 2.5 22 6.977 22 12.5C22 18.023 17.523 22.5 12 22.5ZM11 11.5V17.5H13V11.5H11ZM11 7.5V9.5H13V7.5H11Z",
                            fill: "#44B1FF"
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "ml-3",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-alertBlue font-semibold mb-1",
                            children: title
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-xs",
                            children: message
                        })
                    ]
                })
            ]
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (AlertInfo);


/***/ }),

/***/ 18980:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50959);


function FilterSelectBox(param) {
    var labelName = param.labelName, items = param.items, placeholder = param.placeholder, defaultSelect = param.defaultSelect, setSelected = param.setSelected, name = param.name, innerRef = param.innerRef, filtered = param.filtered, full = param.full;
    var useOutsideAlerter = //when outside of the combobox clicked, it will be closed
    function useOutsideAlerter(ref) {
        (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
            function handleClickOutside(event) {
                if (ref.current && !ref.current.contains(event.target)) {
                    setOpenOptions(false);
                }
            }
            document.addEventListener("mousedown", handleClickOutside);
            return function() {
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, [
            ref
        ]);
    };
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), openOptions = ref[0], setOpenOptions = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(defaultSelect ? defaultSelect : placeholder), selectedItem = ref1[0], setSelectedItem = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(items), filteredItem = ref2[0], setFilteredItem = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), inputValue = ref3[0], setInputValue = ref3[1];
    var onSelectedItem = function(item) {
        setSelectedItem(item);
        setInputValue("");
        setFilteredItem(items);
        setOpenOptions(false);
        if (setSelected) {
            setSelected(item);
        }
    };
    var filterItems = function(e) {
        var name = e.target.value;
        setInputValue(name);
        var newList = items;
        newList = newList.filter(function(a) {
            return a.toLowerCase().search(name.toLowerCase()) !== -1;
        });
        setFilteredItem(newList);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setFilteredItem(items);
    }, [
        items
    ]);
    var wrapperRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    useOutsideAlerter(wrapperRef);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "relative comboBox",
        ref: wrapperRef,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                className: "",
                children: labelName
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                type: "button",
                ref: innerRef,
                name: name,
                onClick: function() {
                    return setOpenOptions(!openOptions);
                },
                className: full ? "flex w-full px-3 py-3   justify-between  rounded-lg border border-makdosSecondaryGray  focus:border-makdosYellow text-gray-700 shadow-sm  bg-white text-sm font-medium  hover:bg-gray-50 focus:outline-none " : "flex w-full lg:w-60 px-3 py-3  mt-1 justify-between  rounded-lg border border-makdosSecondaryGray focus:border-0 focus:ring-1 focus:ring-makdosYellow shadow-sm  bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none ",
                id: "options-menu",
                "aria-haspopup": "true",
                "aria-expanded": "true",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "text-base",
                        children: selectedItem
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "ml-2 bg-makdosSecondaryGray w-0.5 h-5"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                className: "w-5 h-5 ml-1 -mr-1",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 20 20",
                                fill: "currentColor",
                                "aria-hidden": "true",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    fillRule: "evenodd",
                                    d: "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z",
                                    clipRule: "evenodd"
                                })
                            })
                        ]
                    })
                ]
            }),
            openOptions && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: full ? "origin-top-left absolute max-h-44  mt-2 w-full lg:w-full z-10 rounded-lg shadow-lg bg-white overflow-y-auto overflow-x-hidden" : "absolute max-h-44  mt-2 w-3/4 lg:w-60 z-10 rounded-lg shadow-lg bg-white overflow-y-auto overflow-x-hidden",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "py-1",
                    role: "menu",
                    "aria-orientation": "vertical",
                    "aria-labelledby": "options-menu",
                    children: [
                        filtered && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                            onChange: function(e) {
                                return filterItems(e);
                            },
                            value: inputValue,
                            className: "px-4 py-1 w-60 focus:outline-none focus:border-none focus:ring-0",
                            type: "text",
                            placeholder: "Ara ...",
                            autoFocus: true
                        }),
                        filteredItem.map(function(item, i) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                onClick: function() {
                                    return onSelectedItem(item);
                                },
                                className: "w-full px-4 py-3 text-sm font-medium bg-white cursor-pointer hover:bg-makdosSecondaryGray focus:outline-none ",
                                id: "options-menu",
                                "aria-haspopup": "true",
                                "aria-expanded": "true",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "mr-16 text-cardText",
                                    children: item
                                })
                            }, i);
                        })
                    ]
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (FilterSelectBox);


/***/ }),

/***/ 26805:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57135);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80677);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50959);




function SelectBox(param) {
    var selectedItem = param.selectedItem, setSelectedItem = param.setSelectedItem, data = param.data, defaultSelect = param.defaultSelect, label = param.label, style = param.style, itemText = param.itemText;
    var useOutsideAlerter = //when outside of the combobox clicked, it will be closed
    function useOutsideAlerter(ref) {
        (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
            function handleClickOutside(event) {
                if (ref.current && !ref.current.contains(event.target)) {
                    setOpenOptions(false);
                }
            }
            document.addEventListener("mousedown", handleClickOutside);
            return function() {
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, [
            ref
        ]);
    };
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), openOptions = ref[0], setOpenOptions = ref[1];
    var onSelectedItem = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(item) {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
                setOpenOptions(!openOptions);
                setSelectedItem(item);
                return [
                    2
                ];
            });
        });
        return function onSelectedItem(item) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (defaultSelect) setSelectedItem(defaultSelect);
    }, [
        defaultSelect
    ]);
    var wrapperRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    useOutsideAlerter(wrapperRef);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "comboBox relative w-full lg:w-auto ".concat(style && style),
        ref: wrapperRef,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                className: "text-cardText",
                children: label
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                type: "button",
                onClick: function() {
                    return setOpenOptions(!openOptions);
                },
                className: "flex justify-between w-full px-3 py-3 mt-1 text-sm font-medium text-gray-700 bg-white border rounded-lg shadow-sm border-makdosSecondaryGray focus:border-makdosYellow hover:bg-gray-50 focus:outline-none",
                id: "options-menu",
                "aria-haspopup": "true",
                "aria-expanded": "true",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "text-left",
                        children: [
                            selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.text,
                            " ",
                            itemText && itemText
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "ml-2 bg-white w-0.5 h-5"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                className: "w-5 h-5 ml-1 -mr-1",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 20 20",
                                fill: "currentColor",
                                "aria-hidden": "true",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    fillRule: "evenodd",
                                    d: "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z",
                                    clipRule: "evenodd"
                                })
                            })
                        ]
                    })
                ]
            }),
            openOptions && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "absolute z-30 w-full mt-2 origin-top-left bg-white shadow-lg lg:left-0",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "py-1",
                    role: "menu",
                    "aria-orientation": "vertical",
                    "aria-labelledby": "options-menu",
                    children: data.map(function(item, i) {
                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            onClick: function() {
                                return onSelectedItem(item);
                            },
                            className: "w-full px-4 py-3 text-sm font-medium bg-white cursor-pointer hover:bg-makdosSecondaryGray focus:outline-none ",
                            id: "options-menu",
                            "aria-haspopup": "true",
                            "aria-expanded": "true",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                className: "text-cardText",
                                children: [
                                    item.text ? item.text : item === null || item === void 0 ? void 0 : item.method_type,
                                    " ",
                                    itemText && itemText
                                ]
                            })
                        }, i);
                    })
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (SelectBox);


/***/ }),

/***/ 5578:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50959);


function ErrorModal(param) {
    var setOpenModal = param.setOpenModal, title = param.title, message = param.message;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "fixed z-10 inset-0 overflow-y-auto ",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex items-end justify-center min-h-screen pt-4 pb-20 text-center sm:block sm:p-0 ",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "fixed inset-0 transition-opacity",
                    "aria-hidden": "true",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "absolute inset-0 bg-gray-500 opacity-75"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "hidden sm:inline-block sm:align-middle sm:h-screen",
                    "aria-hidden": "true"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-2xl sm:w-full",
                    role: "dialog",
                    "aria-modal": "true",
                    "aria-labelledby": "modal-headline",
                    style: {
                        overflow: "initial"
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "bg-white rounded-md",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "flex justify-end items-center px-3 py-3",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                    onClick: function() {
                                        return setOpenModal(false);
                                    },
                                    className: "ri-close-line text-2xl text-passive cursor-pointer"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "w-full flex flex-col justify-center items-center px-5 pt-4 pb-10 ",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                                        width: "80",
                                        height: "80",
                                        viewBox: "0 0 80 80",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                opacity: "0.2",
                                                d: "M40 70C56.5685 70 70 56.5685 70 40C70 23.4315 56.5685 10 40 10C23.4315 10 10 23.4315 10 40C10 56.5685 23.4315 70 40 70Z",
                                                fill: "#FF433D"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                d: "M40 70C56.5685 70 70 56.5685 70 40C70 23.4315 56.5685 10 40 10C23.4315 10 10 23.4315 10 40C10 56.5685 23.4315 70 40 70Z",
                                                stroke: "#FF433D",
                                                strokeWidth: "6",
                                                strokeMiterlimit: "10"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                d: "M40 25V42.5",
                                                stroke: "#FF433D",
                                                strokeWidth: "6",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                d: "M40 57.5C42.0711 57.5 43.75 55.8211 43.75 53.75C43.75 51.6789 42.0711 50 40 50C37.9289 50 36.25 51.6789 36.25 53.75C36.25 55.8211 37.9289 57.5 40 57.5Z",
                                                fill: "#FF433D"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "mt-5 text-discountRed text-2xl",
                                        children: title
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "mt-5 text-center text-cardText",
                                        children: message
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "w-full mt-10 px-20",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                            onClick: function() {
                                                return setOpenModal(false);
                                            },
                                            type: "button",
                                            className: "w-full py-4 px-4 flex items-center justify-center text-textWhite rounded-md font-medium bg-discountRed hover:bg-makdosLaci hover:text-textWhite transition-colors duration-300 tr text-md focus:outline-none",
                                            children: "Kapat"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (ErrorModal);


/***/ })

}]);